import {toast} from 'react-toastify'
import {isNotEmpty} from '../../../../_metronic/helpers'
import {
  setStatusResponseServer,
  setUserProfileData,
  setValidToken,
} from '../../../common/ModalPopup/reducer'
import {AppStore} from '../../../common/redux/store'
import {AuthModel, AuthStatus} from './_models'
import {getUserByToken, refreshToken} from './_requests'
import {AxiosResponse} from 'axios'
import {HTTPResponseModel} from '../../../common/models/HTTPResponseModel'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
let refreshPromise: Promise<AxiosResponse<HTTPResponseModel, any>> | null = null
const clearPromise = () => (refreshPromise = null)
let getUserPromise: Promise<AxiosResponse<HTTPResponseModel, any>> | null = null
const clearUserPromise = () => (getUserPromise = null)
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth?: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    if (auth) {
      const lsValue = JSON.stringify(auth)
      localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
    } else localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'

  axios.interceptors.request.use(
    (config: {headers: {AppVersion: string; Lang: string; AccessToken: string}}) => {
      const auth = getAuth()
      const lang: any = localStorage.getItem('i18nConfig')
      if ((auth && auth.AccessToken) || AppStore.getState()?.userProfileData?.AccessToken) {
        config.headers.Lang = lang ? JSON.parse(lang)?.selectedLang || 'FR' : `FR`
        config.headers.AppVersion = `1.0`
        config.headers.AccessToken =
          AppStore.getState()?.userProfileData?.AccessToken ||
          config.headers.AccessToken ||
          auth?.AccessToken
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
  axios.interceptors.response.use(
    async (response: any) => {
      if (
        response.data?.Status?.FailureReason ===
        'Access lost (connection to another device detected)'
      ) {
        console.log('FailureReason', response.data?.Status?.FailureReason)
        AppStore.dispatch(setUserProfileData(null))
        setAuth(undefined)
      }
      if (response.data?.Status?.FailureReason === 'Session expired)') {
        console.log('FailureReason', response.data?.Status?.FailureReason)
        AppStore.dispatch(setUserProfileData(null))
        setAuth(undefined)
      }
      if (response.data?.Status?.FailureReason === 'AccessToken Expired') {
        const authUser = getAuth()
        const freshToken = await refreshToken(authUser?.RefreshToken || '')
        if (freshToken?.data?.data?.AccessToken) {
          AppStore.dispatch(
            setUserProfileData({
              ...AppStore.getState()?.userProfileData,
              ...freshToken?.data?.data,
            })
          )
          setAuth({
            ...AppStore.getState()?.userProfileData,
            ...freshToken?.data?.data,
          })
          response.config.headers.AccessToken = `${freshToken?.data?.data?.AccessToken}`
          const userByToken = await getUserByToken(freshToken?.data?.data?.AccessToken)
          console.log('userByToken interceptor', freshToken?.data?.data?.AccessToken)
          if (userByToken?.data?.Status?.FailureReason === 'Session expired') {
            AppStore.dispatch(setUserProfileData(null))
            setAuth(undefined)
            //return userByToken
          }
          if (userByToken && userByToken?.data) {
            AppStore.dispatch(setUserProfileData(userByToken?.data?.data))
            setAuth(userByToken?.data?.data)
            return axios(response.config)
          }
        }
      }
      return response
    },

    // async (response: any) => {
    //   if (
    //     response?.data?.Status.Message ||
    //     response?.data?.Status.Toast ||
    //     response.data?.Status?.FailureReason
    //   ) {
    //     AppStore.dispatch(setStatusResponseServer(response?.data?.Status))
    //     if (response?.data?.Status.Toast) {
    //       if (response?.data?.Status?.ToastType == 'Success') {
    //         toast.success(response?.data?.Status.Toast)
    //       }
    //       if (response?.data?.Status?.ToastType == 'Error') {
    //         toast.error(response?.data?.Status.Toast)
    //       }
    //     }
    //   }
    //   if (
    //     response?.data?.Status?.FailureReason === 'Session expired' ||
    //     response.data?.Status?.FailureReason ===
    //       'Access lost (connection to another device detected)' ||
    //     response.data?.Status?.FailureReason === AuthStatus.SESSION_EXPIRED ||
    //     response.data?.Status?.FailureReason === AuthStatus.SESSION_EXPIRED_V2
    //   ) {
    //     response.config.headers.AccessToken = null
    //     AppStore.dispatch(setUserProfileData(null))
    //     setAuth(undefined)
    //     AppStore.dispatch(setValidToken(false))
    //     return
    //   }
    //   if (
    //     response.data?.Status?.FailureReason ===
    //     'Incorrect RefreshToken or AccessToken not expired)'
    //   ) {
    //     response.config.headers.AccessToken = null
    //     AppStore.dispatch(setUserProfileData(null))
    //     setAuth(undefined)
    //     AppStore.dispatch(setValidToken(false))
    //     return
    //   }

    //   if (response.data?.Status?.FailureReason === AuthStatus.ACCESSTOKEN_EXPIRED) {
    //     const authUser = getAuth()
    //     if (!isNotEmpty(authUser?.RefreshToken)) {
    //       AppStore.dispatch(setUserProfileData(null))
    //       setAuth(undefined)
    //     }
    //     let isRefreshed = true
    //     if (!refreshPromise) {
    //       refreshPromise = refreshToken(authUser?.RefreshToken || '').finally(clearPromise)
    //     }
    //     const freshToken = await refreshPromise
    //     if (freshToken?.data?.data?.AccessToken) {
    //       AppStore.dispatch(
    //         setUserProfileData({
    //           ...AppStore.getState()?.userProfileData,
    //           ...freshToken?.data?.data,
    //         })
    //       )
    //       setAuth({
    //         ...AppStore.getState()?.userProfileData,
    //         ...freshToken?.data?.data,
    //       })
    //       response.config.headers.AccessToken = `${freshToken?.data?.data?.AccessToken}`
    //       AppStore.dispatch(setValidToken(true))
    //       if (!getUserPromise) {
    //         getUserPromise = getUserByToken(freshToken?.data?.data?.AccessToken).finally(
    //           clearUserPromise
    //         )
    //       }
    //       const userByToken = await getUserPromise
    //       if (
    //         userByToken.data?.Status?.FailureReason === AuthStatus.ACCESS_LOST ||
    //         userByToken.data?.Status?.FailureReason === AuthStatus.SESSION_EXPIRED ||
    //         userByToken.data?.Status?.FailureReason === AuthStatus.SESSION_EXPIRED_V2
    //       ) {
    //         response.config.headers.AccessToken = null
    //         AppStore.dispatch(setUserProfileData(null))
    //         setAuth(undefined)
    //         AppStore.dispatch(setValidToken(false))
    //         return
    //       }
    //       if (userByToken && userByToken?.data) {
    //         AppStore.dispatch(setUserProfileData(userByToken?.data?.data))
    //         setAuth(userByToken?.data?.data)
    //         AppStore.dispatch(setValidToken(true))
    //         return axios(response.config)
    //       }
    //     } else if (!isNotEmpty(freshToken?.data?.data)) {
    //       AppStore.dispatch(setUserProfileData(null))
    //       setAuth(undefined)
    //       AppStore.dispatch(setValidToken(false))
    //       return
    //     }
    //   }
    //   return response
    // },
    (error: any) => {
      return {errorMessage: 'Network error'}
    }
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
